var baseURL = "/employee";
var timetables = "".concat(baseURL, "/timetables");
export var employee = {
    home: function () { return timetables; },
    timetables: {
        index: function () { return timetables; },
    },
};
